import React, { useEffect, useState } from "react";
import Constants from "../../../../utils/Constants";
import axios from "axios";
import UIkit from "uikit";
import { useForm } from "react-hook-form";
import InvoiceShow from "./InvoiceShow";






const InvoiceModal = ({loader , data, slipType  }) => {


  const {
    
  register : invoicebankregister ,
  handleSubmit : handleinvoiceSubmit   } = 
  useForm()



  const [bankdata, setbankdata] = useState(null);
  const [banks, setbanks] = useState(null);
  const [invoice, setinvoice] = useState(null);





  const GenerateInvoice = (selectedbankID) => { 

  const selectedbank = banks.find(bank => bank._id === selectedbankID.bank_id)
    if (selectedbank) {
      setbankdata(selectedbank);
    }

  }


  useEffect(() => {
    axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: Constants.url + `payment/list-banks`,
    })
      .then((res) => {
        if (res.data.status === "success") {
          setbanks(res.data.data.bank || []);
        }
      })
      .catch((err) => {});

      
    // network call for getting Invoice Number that is to be sent in invoice show component 

    axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: Constants.url + `orders/get-pbo-counter`,
    })
      .then((res) => {

        if (res.data.status === "success") {
          setinvoice(res.data.data.pboField || null);
        }
      })
      .catch((err) => {console.log('pbo invoice api failed')});
  }, []);






  return (

    
    <>

      
    {!bankdata ?  
    //bank selector modal if the bank is not selected this popup will show
    <div className="uk-modal-dialog uk-modal-body uk-card uk-card-default uk-card-hover uk-width-large ">
      <button className="uk-modal-close-default" type="button" uk-close>
        X
      </button>

      <h3 className="uk-text-bold uk-text-light">Generate Invoice </h3>

      <form
        className="uk-form-stacked uk-padding "
        onSubmit={handleinvoiceSubmit(GenerateInvoice)}
      >
        <div className="uk-margin-small">
          <label className="uk-form-label">Banks</label>

          <select
          {...invoicebankregister("bank_id", {
            required: "Field is required",
          })}
          >
            <option value="">Select Bank</option>
            {banks?.map((bank, index) => (
              <option key={index} value={bank._id}>
                {bank.name}
              </option>
            ))}
            {/* Add a default option */}
          </select>
        </div>

        <div className="uk-margin-small uk-flex uk-flex-center">
          <button
            className="uk-button uk-button-secondary uk-button-medium uk-width-1-1"
            type="submit"
            onClick={GenerateInvoice}
          >
            {loader ? <div uk-spinner="" className="loader"></div> : "Select"}
          </button>
        </div>
      </form>
    </div>

    :
    
    //Invoice popup  


    <div className="  uk-modal-dialog  " style={{width:'1200px'}}>
      <button className="uk-modal-close-default" type="button" uk-close>
        X
      </button>
      {/* INvoice Component  */}
      <InvoiceShow  BankInvoice = {invoice}  bankdata = {bankdata} orderData = {data} slipType={slipType} />
    </div>
    
    }
    
    </>

    
  );
};

export default InvoiceModal;
